import React from 'react';
import { useLocation } from 'react-router-dom';
// import Responses from 'screens/company-user/job/job-v1/responses';
import TimelineAndComments from 'screens/company-user/job/job-v1/timeline-and-comments';

import { Paper } from '@mui/material';
import { makeStyles } from '@mui/styles';

import { Job } from '@libs/graphql-types';

import { JobTabType } from '../job-tabs';
import { Ats } from './ats';
import { CampaignDetails } from './campaign-details';

const useStyles = makeStyles((theme: any) => ({
  root: {
    backgroundColor: '#fff',
    borderRadius: theme.shape.borderRadius,
  },
  rootWithoutBackground: {
    borderRadius: theme.shape.borderRadius,
    backgroundColor: 'transparent',
  },
  title: {
    fontSize: '1.125rem',
    fontWeight: 500,
    marginBottom: theme.spacing(2),
  },
  placeholder: {
    color: theme.palette.text.secondary,
    fontSize: '0.875rem',
  },
}));

interface TabContentProps {
  jobData?: Job;
}

export const TabContent: React.FC<TabContentProps> = ({ jobData }) => {
  const classes = useStyles();
  const location = useLocation();

  // Get the tab from the URL or default to CAMPAIGN_DETAILS
  const searchParams = new URLSearchParams(location.search);
  const currentTab =
    (searchParams.get('tab') as JobTabType) || JobTabType.CAMPAIGN_DETAILS;

  if (!jobData) {
    return null;
  }

  const renderContent = () => {
    switch (currentTab) {
      case JobTabType.CAMPAIGN_DETAILS:
        return <CampaignDetails jobData={jobData} />;
      case JobTabType.ATS:
        return <Ats jobData={jobData} />;
      // return <Responses job={jobData} hideFilter={true} />;
      case JobTabType.COMMENTS_TIMELINE:
        return <TimelineAndComments job={jobData} />;
      default:
        return null;
    }
  };

  // For ATS tab, use the version without background and transparent paper
  const rootClass =
    currentTab === JobTabType.ATS
      ? classes.rootWithoutBackground
      : classes.root;

  return (
    <Paper
      className={rootClass}
      elevation={0}
      sx={
        currentTab === JobTabType.ATS
          ? { boxShadow: 'none', background: 'transparent' }
          : {}
      }
    >
      {renderContent()}
    </Paper>
  );
};
